module.exports = __webpack_public_path__ + "img/type_left_bg.37412620.png";